import React from "react";
export default function Svg_401() {
  return (
    <svg
      width="489"
      height="342"
      viewBox="0 0 489 342"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2202_235)">
        <g filter="url(#filter0_i_2202_235)">
          <path
            d="M154.612 195.802V231.471H10.8379L8.09416 203.21L88.3498 74.1152H124.842L85.1944 139.006L52.269 195.802H154.612ZM134.445 74.1152V273.862H88.2126V74.1152H134.445ZM314.026 155.743V192.235C314.026 206.594 312.334 219.078 308.95 229.688C305.657 240.297 300.901 249.077 294.682 256.028C288.554 262.979 281.238 268.146 272.732 271.53C264.226 274.914 254.852 276.606 244.608 276.606C236.377 276.606 228.694 275.554 221.56 273.451C214.427 271.256 207.979 267.963 202.217 263.573C196.546 259.092 191.653 253.513 187.538 246.836C183.422 240.16 180.266 232.294 178.071 223.24C175.876 214.094 174.779 203.759 174.779 192.235V155.743C174.779 141.292 176.425 128.808 179.718 118.29C183.102 107.681 187.903 98.9006 194.123 91.9497C200.342 84.9988 207.704 79.8314 216.21 76.4474C224.716 73.0634 234.09 71.3714 244.334 71.3714C252.565 71.3714 260.202 72.4689 267.244 74.6639C274.378 76.7675 280.826 80.06 286.588 84.5415C292.35 88.9316 297.243 94.4649 301.267 101.141C305.383 107.818 308.538 115.729 310.733 124.875C312.928 133.93 314.026 144.219 314.026 155.743ZM267.793 197.86V149.844C267.793 143.441 267.427 137.862 266.696 133.106C266.055 128.351 265.049 124.326 263.677 121.034C262.397 117.741 260.796 115.089 258.876 113.077C256.955 110.973 254.76 109.464 252.291 108.55C249.913 107.544 247.26 107.041 244.334 107.041C240.675 107.041 237.383 107.818 234.456 109.373C231.621 110.836 229.197 113.214 227.185 116.507C225.173 119.799 223.618 124.189 222.521 129.677C221.515 135.164 221.012 141.887 221.012 149.844V197.86C221.012 204.353 221.332 210.024 221.972 214.871C222.704 219.627 223.71 223.697 224.99 227.081C226.362 230.374 228.008 233.072 229.929 235.175C231.85 237.187 234.045 238.651 236.514 239.565C238.983 240.48 241.681 240.937 244.608 240.937C248.175 240.937 251.376 240.205 254.211 238.742C257.047 237.279 259.47 234.901 261.482 231.608C263.586 228.224 265.141 223.788 266.147 218.301C267.244 212.722 267.793 205.908 267.793 197.86ZM440.651 74.1152V273.862H394.419V126.247L348.872 139.554V104.434L436.399 74.1152H440.651Z"
            fill="#C1C3B9"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_i_2202_235"
          x="3.59883"
          y="71.3713"
          width="437.053"
          height="209.73"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-4.5" dy="4.49541" />
          <feGaussianBlur stdDeviation="2.24771" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.93238 0 0 0 0 0.951667 0 0 0 0 0.710578 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_2202_235"
          />
        </filter>
        <clipPath id="clip0_2202_235">
          <rect
            width="489"
            height="341"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
